import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@client/components/coming-soon";
import { useUiTranslation } from "@tubo/ui/i18n";

export const Route = createFileRoute("/_app/search")({
  component: SearchPage,
});

function SearchPage() {
  const { t } = useUiTranslation("auxiliaryPages");
  return <ComingSoon title={t("search.title")} message={t("search.comingSoon")} />;
}
